import VisitsTable from "./visits-table";

export default VisitsTable;